import { render } from "./NavbarCombined.vue?vue&type=template&id=71929481&scoped=true"
import script from "./NavbarCombined.vue?vue&type=script&lang=js"
export * from "./NavbarCombined.vue?vue&type=script&lang=js"

import "./NavbarCombined.vue?vue&type=style&index=0&id=71929481&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71929481"]])

export default __exports__